<template>
  <v-container>
    <rest-resource-table
      label="Users"
      resource-name="users"
      resource-id-name="id"
      @saved="$store.dispatch('LOAD_CONFIG')"
      allow-new
      :allow-delete="false"
      edit-permission="editUsers"
      :columns="columnHeaders"
      :loading="loading.all"
      :filter="{ include: 'rolemapping' }"
      ref="usersTable"
    >
      <template v-slot:item.rolemapping="{ item }">
        <ul>
          <li
            v-for="rolemap of displayRoles(item.rolemapping)"
            :key="`user-${rolemap}`"
          >
            {{ rolemap }}
          </li>
        </ul>
      </template>

      <template v-slot:form="{ item }">
        <div>
          <v-text-field
            label="Username"
            :disabled="!!item.id"
            v-model="item.username"
          />
          <v-text-field label="email" v-model="item.email" />

          <v-text-field
            type="password"
            label="Password"
            v-model="item.password"
            hint="(Leave blank to remain unchanged)"
            persistent-hint
          />

          <v-divider />

          <v-select
            label="Roles"
            v-if="item && item.rolemapping"
            :value="roleValue(item.rolemapping)"
            :items="roleOptions"
            multiple
            chips
            small-chips
            @input="$event => updateRoleMapping(item, $event)"
            :loading="loading[item.id]"
          ></v-select>

          <!-- <v-text-field
            label="Password"
            v-model="item.publicRegisterLabel"
          /> -->
          <!-- <lookup-select
            lookup-name="PractisingStatus"
            label="Legacy Practicing Status"
            v-model="item.practicingStatusId"
            clearable
            persistent-hint
            hint="When auto-switching to this status, what should the legacy pracStatus field be changed to?"
          ></lookup-select> -->
          <!-- <v-checkbox label="inactive" v-model="item.inactive"></v-checkbox> -->
        </div>
      </template>
    </rest-resource-table>

    <!-- <current-user-can permission="editUsers">
      <v-card>
        <v-card-title>
          Users
        </v-card-title>

        <section>
          <v-alert v-if="error">{{ error }}</v-alert>
          <v-data-table
            :message="error"
            :items="users"
            :headers="columnHeaders"
            :loading="loading.all"
            :items-per-page="20"
          >
            
          </v-data-table>
        </section>
      </v-card>
    </current-user-can> -->
  </v-container>
</template>

<script>
export default {
  name: "AdminUsers",
  data() {
    return {
      loading: {
        all: false
      },
      error: "",
      roles: [],
      columnHeaders: [
        {
          text: "id",
          value: "id",
          width: "2em",
          sortable: false
        },
        {
          text: "realm",
          value: "realm",
          width: "5em",
          sortable: false
        },
        {
          text: "Username",
          value: "username"
        },
        {
          text: "Email",
          value: "email"
        },
        // {
        //   text: "ms Tenant",
        //   value: "msTenantId"
        // },
        {
          text: "Roles",
          value: "rolemapping",
          sortable: false
        }
      ]
    };
  },
  async created() {
    try {
      this.loading.all = true;
      // await this.getUsers();
      await this.getRoles();
    } catch (e) {
      this.error = e;
    } finally {
      this.loading.all = false;
    }
  },
  computed: {
    roleOptions() {
      return this.roles
        .map(r => {
          return {
            text: r.name.startsWith("S-1")
              ? "(MSTeam) " + r.description
              : r.name,
            value: r.id
          };
        })
        .filter(r => !r.text.startsWith("(MS"));
    }
  },
  methods: {
    roleValue(rolemapping) {
      console.log("roleValue: ", rolemapping);
      try {
        return rolemapping.map(r => (r.role ? r.role.id : null)).filter(r => r);
      } catch (e) {
        console.error(rolemapping, e);
        return [];
      }
    },
    displayRoles(roleMapps) {
      try {
        return roleMapps
          .map(rm => rm.role)
          .filter(r => r?.permissions?.length)
          .map(r => {
            return r.name.startsWith("S-1")
              ? `(MSTeam) ${r.description}`
              : r.name;
          });
      } catch (e) {
        return [];
      }
    },
    async getPermissions() {
      let permOptions = await this.$http.get("marcopermissionoptions");
      this.permissionOptions = [...permOptions.data];
    },
    async getRoles() {
      let roles = await this.$http.get("roles");
      this.roles = [...roles.data];
    },
    async updatePermission(item, perm) {
      try {
        this.$set(this.loading, item.role + "-" + perm, true);
        if (!item[perm]) {
          console.log("adding permissions: ", item, perm);
          await this.$http.post(`roles/${item.roleId}/permissions`, {
            name: perm,
            permission: perm
          });
        } else {
          console.log("removing permissions: ", item, perm);
          let role = this.roles.find(r => r.id === item.roleId);
          let rolePerm = role.permissions.find(rp => rp.permission === perm);
          await this.$http.delete(
            `roles/${item.roleId}/permissions/${rolePerm.id}`
          );
        }
        await this.getRoles();
      } catch (e) {
        console.error("error removing permission: ", e);
      } finally {
        this.$set(this.loading, item.role + "-" + perm, false);
      }
    },
    setRoleName(name) {
      this.newRoleName = name
        .trim()
        .toLowerCase()
        .replace(/\W/g, "_");
    },
    async createRole() {
      try {
        this.loading.newRole = true;
        if (!this.newRoleName) {
          return false;
        }
        let result = await this.$http.post("roles", {
          name: this.newRoleName,
          description: this.newRoleDescription
        });

        this.newRoleDialog = false;
        this.newRoleName = "";
        this.newRoleDescription = "";
        this.newRoleError = "";
      } catch (e) {
        this.newRoleError = e.message;
      } finally {
        this.loading.newRole = false;
        await this.getRoles();
      }
    },
    async updateRoleMapping(user, selectedRoles) {
      try {
        this.$set(this.loading, user.id, true);

        console.log("changed roles selection: ", user, selectedRoles);
        const currentRoles = user.rolemapping
          .filter(rm => rm.role)
          .map(rm => rm.role.id);

        let deletions = currentRoles.filter(id => !selectedRoles.includes(id));
        let additions = selectedRoles.filter(id => !currentRoles.includes(id));

        if (deletions.length) {
          for (const roleId of deletions) {
            const roleMap = user.rolemapping.find(rm => rm.roleId === roleId);
            console.log("delete roleId: ", roleId, roleMap);
            await this.$http.delete(
              `users/${user.id}/rolemapping/${roleMap.id}`
            );
          }
        }

        if (additions.length) {
          for (const roleId of additions) {
            console.log("add roleId: ", roleId);
            await this.$http.post(`users/${user.id}/rolemapping`, {
              principalType: "USER",
              principalId: user.id,
              roleId: roleId
            });
          }
        }
      } catch (e) {
        this.error = e;
      } finally {
        this.$set(this.loading, user.id, false);

        this.$refs["usersTable"].refresh();
      }
    }
  }
};
</script>
